import React, { FC, HTMLProps } from "react";
import Tooltip, { TooltipProps } from "./Tooltip";
import cn from "classnames";
import { AiOutlineInfo } from "react-icons/ai";
import stl from "./Info.module.scss";

interface Props extends HTMLProps<HTMLDivElement> {
  tooltipProps?: Omit<TooltipProps, "overlay">;
}

const Info: FC<Props> = ({ tooltipProps, children, className, ...props }) => {
  return (
    <Tooltip {...tooltipProps} overlay={children}>
      <div {...props} className={cn(className, stl.block)}>
        <AiOutlineInfo className={stl.ico} />
      </div>
    </Tooltip>
  );
};

export default Info;
